module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "imageUploader"
  }, [_c('vue-base64-file-upload', {
    staticClass: "v1",
    attrs: {
      "id": 'uploader-' + _vm._uid,
      "accept": "image/png,image/jpeg",
      "image-class": "v1-image",
      "input-class": "imageInput",
      "max-size": _vm.maxSize
    },
    on: {
      "size-exceeded": _vm.onSizeExceeded,
      "load": _vm.onLoad
    }
  }), _vm._v(" "), (!_vm.isUploading) ? _c('mu-icon', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.bottom",
      value: (_vm.label),
      expression: "label",
      modifiers: {
        "bottom": true
      }
    }],
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "size": _vm.size,
      "color": "#0179d5",
      "value": _vm.icon
    },
    nativeOn: {
      "click": function($event) {
        return _vm.selectFile.apply(null, arguments)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isUploading) ? _c('mu-circular-progress', {
    attrs: {
      "size": _vm.size,
      "mode": "determinate",
      "value": _vm.progress
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f1e4d51","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ImageUploader/ImageUploader.vue
// module id = 3804
// module chunks = 1